<template>
	<div>
		<el-dialog title="配置显示名" center :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="700px">
			<div class="show-top">
				<el-button size="mini" type="primary" @click="handleAdd">新增</el-button>
			</div>
			<el-table :data="showList" :row-class-name="tableRowClassName" :header-cell-style="{ color: '#444' }" border>
				<el-table-column label="序号" align="center" width="60">
					<template slot-scope="scope">
						{{ scope.$index + 1 }}
					</template>
				</el-table-column>
				<el-table-column label="显示名称" align="center" prop="showName"></el-table-column>
				<el-table-column label="排序" align="center" prop="showSort" width="80"></el-table-column>
				<el-table-column label="操作" align="center" width="120">
					<template slot-scope="scope">
						<el-button size="mini" type="text" @click="handleEdit(scope.row)">编辑</el-button>
						<el-button size="mini" type="text" class="delete-text" @click="handleDel(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogVisible = false">确定</el-button>
			</span>
		</el-dialog>
		<ShowNameDialog ref="showNameDialogRef" @refresh="getList" />
	</div>
</template>

<script>
import { courseSkillShowList, courseSkillShowDel } from "@/api/skill";
import ShowNameDialog from "./ShowNameDialog.vue";
export default {
	components: {
		ShowNameDialog,
	},
	data() {
		return {
			dialogVisible: false,
			skillId: "",
			showList: [],
		};
	},
	methods: {
		// 初始化弹窗
		init(skillId) {
			this.dialogVisible = true;
			this.skillId = skillId;
			this.getList();
		},
		// NO.隔行变色
		tableRowClassName({ row, rowIndex }) {
			if (rowIndex % 2 == 1) {
				return "blue";
			} else {
				return "yellow";
			}
		},
		// 获取列表
		getList() {
			courseSkillShowList({ skillId: this.skillId }, true).then((res) => {
				if (res.code != "0") return this.$message.error(res.msg);
				this.showList = res.data;
			});
		},
		handleAdd() {
			this.$refs.showNameDialogRef.init(this.skillId);
		},
		handleEdit(row) {
			this.$refs.showNameDialogRef.init(this.skillId, row);
		},
		handleDel(row) {
			this.$confirm(`确认删除显示名称【${row.showName}】吗？`, "提示", { type: "warning" }).then(() => {
				courseSkillShowDel({ id: row.id }).then((res) => {
					if (res.code != "0") return this.$message.error(res.msg);
					this.getList();
				});
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.show-top {
	margin-bottom: 15px;
	text-align: right;
}
.delete-text {
	color: #f56c6c;
}
.el-table ::v-deep td,
.el-table ::v-deep th {
	padding: 5px 0;
}
::v-deep .el-dialog__body {
	padding: 0 15px 15px;
}
</style>
